module.exports = __webpack_public_path__ + "img/knee-90.ba1ecd8d.svg";